import {Suspense, type PropsWithChildren} from 'react'
import {ErrorBoundary} from '@github-ui/react-core/error-boundary'
import {ForYouItemError, ForYouItemSkeleton} from './ForYouItemFallbacks'

/**
 * Error boundary and suspense wrapper for individual ForYouItems.
 * Each item is wrapped in its own boundary so that if one item fails to load, it doesn't take down the entire section.
 * The fallback states mirror the collapsed state of ForYouItem to preserve layout stability.
 */
export function ForYouItemBoundary({children, name}: PropsWithChildren<{name: string}>) {
  return (
    <ErrorBoundary boundaryName={`ForYouItem.${name}`} fallback={<ForYouItemError />}>
      <Suspense fallback={<ForYouItemSkeleton />}>{children}</Suspense>
    </ErrorBoundary>
  )
}
